var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 29",
    style: {
      enableBackground: "new 0 0 30 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F5D89;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,0.8c-2.4,0-4,1.1-4.9,2.1C9.4,3.5,9.1,4,9,4.5C7.2,4.8,6,6,5.5,7.1C5.1,7.9,5,8.6,4.9,9 c-0.3,0.2-0.6,0.6-0.9,1c-0.6,1-1.2,2.5-1.2,4.7c0,1.4,0.6,3.6,2.4,5.6c1.7,1.9,4.4,3.5,8.6,3.7l-0.1,4.2h3.1l-0.4-8.9l4.6-4.6 l-0.5-1l-4.2,2.9l-0.5-9.1h-1.5L14,13.2l-3.7-2.7l-0.6,0.7l2.1,2.2l-3.5,1.9L8.6,16l4.1-1.5l1.3,1.1L13.8,22c-3.6-0.2-5.7-1.5-7.1-3 c-1.4-1.6-1.9-3.5-1.9-4.2c0-1.9,0.5-3,0.9-3.6c0.4-0.6,0.6-0.7,0.6-0.7l0.6-0.3l0-0.6c0,0,0-0.8,0.4-1.6c0.4-0.8,1-1.5,2.5-1.7 l0.8-0.1l0.1-0.8c0,0,0.1-0.6,0.6-1.3c0.5-0.7,1.4-1.3,3.2-1.3c2.5,0,3.6,1.3,4.4,2.8c0.7,1.5,0.8,3,0.8,3l0,0.6l0.5,0.3 c0,0,3.6,1.8,3.6,5.3c0,2.4-1.4,4.1-2.9,5.2C19.5,21,18,21.5,18,21.5l0.6,2c0,0,1.8-0.6,3.7-1.9c1.8-1.3,3.8-3.6,3.8-6.8 c0-4-3.1-6.2-4.2-6.8c-0.1-0.6-0.2-1.8-0.9-3.2C20,2.9,18,0.8,14.7,0.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIcon);
export default __webpack_public_path__ + "static/media/tree-icon.7acdd754ea0fc2fcdce2bc09a938e39b.svg";
export { ForwardRef as ReactComponent };